<template>
  <div>
    <div class="chip-container">
      <div class="chips">
        <vs-chip v-for="chip in chips" :key="chip.id" closable color="#7E72F2" class="chip m-0" @click="removeChip(chip)">
          {{ chip.name }}
        </vs-chip>
      </div>
      <div class="popup-icon" @click="showPopup = true">
        <feather-icon icon="UsersIcon" />
      </div>
    </div>
    <vs-popup title="사용자 검색" :active.sync="showPopup" id="alertUserSelectPopup">
      <search-nav @handleSearch="handleSearch">
        <search-nav-item-keyword label="현장명" size="small" v-model="search.field" :viewLabel="true" />
        <search-nav-item-keyword label="소속명" size="small" v-model="search.com" :viewLabel="true" />
        <search-nav-item-keyword label="부서명" size="small" v-model="search.section" :viewLabel="true" />
        <search-nav-item-keyword label="키워드" size="small" v-model="search.keyword" :viewLabel="true" />
      </search-nav>
      <div>
        <table>
          <colgroup>
            <col width="40" />
          </colgroup>
          <thead>
            <th><vs-checkbox :value="allCheck" @click.native="onClickAllCheck" /></th>
            <th>현장명</th>
            <th>소속명</th>
            <th>부서명</th>
            <th>이름</th>
          </thead>
          <tbody>
            <tr v-for="user in userList" :key="user.id">
              <td><vs-checkbox v-model="checkIds" :vs-value="user.id" @change="(e) => onChangeCheckbox(e, { id: user.id, name: user.name })" /></td>
              <td>{{ getFieldName(user.fields) }}</td>
              <td>{{ !!user.company ? user.company.com_name : "" }}</td>
              <td>{{ user.section }}</td>
              <td>{{ user.name }}</td>
            </tr>
          </tbody>
        </table>
        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage" />
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end mt-4">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button color="secondary" @click="handleClickSelect">선택</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import KPagination from "@/components/kPagination/kPagination";

export default {
  name: "AlertUserSelector",
  components: {
    SearchNav,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    KPagination,
  },
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      showPopup: false,
      checkIds: this.value.map((v) => v.id),
      checkData: this.value,
      chips: this.value,
      search: { field: "", com: "", section: "", keyword: "" },
      page: {
        current: 1,
        lastPage: 1,
        perPage: 5,
      },
    };
  },
  computed: {
    userList() {
      return this.$store.state.member.list;
    },
    allCheck() {
      if (0 < this.userList.length) {
        return this.userList.reduce((_prev, _ul) => _prev && this.checkIds.includes(_ul.id), true);
      } else return false;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.chips = value;
      },
    },
    chips: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    showPopup(value) {
      if (value) {
        this.page = {
          current: 1,
          lastPage: 1,
          perPage: 5,
        };
        this.search = { field: "", com: "", section: "", keyword: "" };
        this.loadUsers();
      }
    },
  },
  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
  methods: {
    handleSearch() {
      if (!!this.search.field || !!this.search.com || !!this.search.section || !!this.search.keyword) {
        this.page = {
          current: 1,
          lastPage: 1,
          perPage: 5,
        };
        this.loadUsers();
      }
    },
    async loadUsers() {
      const { current, lastPage, perPage } = this.page;
      const { field, com, section, keyword } = this.search;

      const params = { searchType: "and", page: current, perPage, projectId: this.$route.params.proj_id, field, company: com, section, keyword };

      await this.$store.dispatch("member/LOAD_MEMBERS", params);

      const listInfo = this.$store.state.member.listInfo;
      this.page.lastPage = listInfo.last_page;
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadUsers();
    },
    onClickAllCheck() {
      const listIds = this.userList.map((ul) => ul.id);
      if (this.allCheck) {
        this.checkData = this.checkData.filter((cd) => !listIds.includes(cd.id));
        this.checkIds = this.checkData.map((cd) => cd.id);
      } else {
        const clean = this.checkData.filter((cd) => !listIds.includes(cd.id));
        const newData = this.userList.map((ul) => {
          return { id: ul.id, name: ul.name };
        });

        this.checkData = [...clean, ...newData];
        this.checkIds = this.checkData.map((cd) => cd.id);
      }
    },
    onChangeCheckbox(e, data) {
      if (e.includes(data.id)) this.checkData.push(data);
      else this.checkData = this.checkData.filter((cd) => cd.id !== data.id);
    },
    handleClickClose() {
      this.checkData = this.chips;
      this.checkIds = this.chips.map((_c) => _c.id);
      this.showPopup = false;
    },
    handleClickSelect() {
      this.chips = this.checkData;
      this.showPopup = false;
    },
    removeChip(data) {
      this.chips = this.chips.filter((chip) => chip.id !== data.id);
      this.checkData = this.chips;
      this.checkIds = this.chips.map((_c) => _c.id);
    },
    getFieldName(fields) {
      if (!!fields) {
        const names = fields.map((_f) => _f.field_name);
        return names.join(", ");
      } else return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-container {
  width: 100%;
  min-height: 40px;

  display: flex;
  justify-content: space-between;

  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 5px;

  padding: 6px 10px;

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 4px;

    .chip::v-deep {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      border-radius: 4px;
      .btn-close {
        background: none;
        i {
          font-size: 8px;
        }
      }
    }
  }

  .popup-icon {
    min-height: 100%;
    display: flex;
    border-left: solid 1px #cdcdcd;
    padding-left: 10px;
    user-select: none;
    cursor: pointer;
  }
}

#alertUserSelectPopup::v-deep {
  .vs-popup {
    width: 90%;
  }

  @media screen and (min-width: theme("screens.xl")) {
    .vs-popup {
      width: 70%;
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f9f9f9;

  th,
  td {
    font-size: 14px;
    text-align: center;

    padding: 10px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  thead,
  tr {
    th:first-child,
    td:first-child {
      padding: 10px 0;
    }
  }

  tbody {
    tr:nth-child(2n -1) {
      background: #f9f9f9;
    }
  }
}
</style>
